<template>
  <q-layout
    container
    class="tw-text-gray-600 tw-bg shadow-1 tw-min-h-full bg-white"
  >
    <div class="tw-flex tw-justify-between tw-h-16 tw-items-center">
      <div class="tw-fixed tw-bg-white tw-w-full tw-z-30" >
        <h5 class="tw-text-xl tw-ml-4">
        {{ title }}
         </h5>
      </div>
      <div></div>
      <div class="tw-mr-4 tw-z-40">
        <q-btn v-if="buttonTitle" flat @click="actionButton" id="incluirButton">
          <q-icon :name="buttonIconName"/>
          {{ buttonTitle }}
        </q-btn>
        <slot name="buttons"/>
      </div>
    </div>
    <slot/>
  </q-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'MainContentLayout',
  props: {
    title: String,
    buttonTitle: String,
    buttonIconName: String,
    actionButton: Function
  }
})
class MainContentLayout extends Vue {
}
export default MainContentLayout
</script>
<style scoped>
 @import "tailwindcss/utilities";
 </style>
